import { Theme } from "@mui/material";
import { size } from "lib/theme/size";
import { SxObjType } from "lib/theme/types/SxObjType.type";

export const sxStyles = (theme: Theme) => {
  const borderColor = theme.palette.secondary.light;
  return {
    title: {
      typography: theme.typography.header4_semibold,
      color: theme.palette.primary.dark,
      m: 2,
    },
    bookedSlotDetailsContainer: { m: 2 },
    slotsSectionTitle: {
      mx: 2,
      typography: theme.typography.body1_semibold,
      color: theme.palette.grey[400],
    },
    radioListContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      flex: 1,
    },
    layout: {
      width: "100%",
      marginTop: theme.spacing(1),
    },
    radio: {
      color: theme.palette.primary.main,
      paddingTop: 0,
      "& .MuiSvgIcon-root": {
        fontSize: size.FONTSIZE_24,
      },
    },
    listItem: {
      padding: theme.spacing(1, 2),
      marginRight: 0,
      borderBottom: `1px solid ${borderColor}`,
      alignItems: "flex-start",
      "& .MuiRadio-colorPrimary.Mui-checked": {
        color: theme.palette.primary.main,
      },
      "& .MuiFormControlLabel-label": {
        color: theme.palette.grey[400],
        typography: theme.typography.body2_regular,
        marginBottom: theme.spacing(0.5),
      },
    },
    listItemText: {
      color: theme.palette.grey[400],
      typography: theme.typography.body2_semibold,
    },
    bottomContainer: {
      p: 2,
    },
  } satisfies SxObjType;
};
